type GetAccessTokenFn = (options?: {
  cacheMode?: "on" | "off";
}) => Promise<string>;

type LogoutFn = (options?: {
  logoutParams?: { returnTo?: string };
}) => void;

let _getAccessTokenSilently: GetAccessTokenFn | null = null;
let _logout: LogoutFn | null = null;

export function registerAuthFunctions(
  getAccessTokenSilently: GetAccessTokenFn,
  logout: LogoutFn,
) {
  _getAccessTokenSilently = getAccessTokenSilently;
  _logout = logout;
}

export function unregisterAuthFunctions() {
  _getAccessTokenSilently = null;
  _logout = null;
}

/**
 * Get a fresh access token. The Auth0 SDK handles caching and refresh
 * internally — a network call only happens when the cached token is expired.
 */
export async function getAccessToken(): Promise<string> {
  if (!_getAccessTokenSilently) {
    throw new Error("Auth not initialised");
  }
  return _getAccessTokenSilently();
}

/**
 * Force-refresh the access token, bypassing the SDK cache.
 * Used after a 401 to ensure we're not retrying with the same stale token.
 */
export async function forceRefreshToken(): Promise<string> {
  if (!_getAccessTokenSilently) {
    throw new Error("Auth not initialised");
  }
  return _getAccessTokenSilently({ cacheMode: "off" });
}

export function logoutUser() {
  _logout?.({ logoutParams: { returnTo: window.location.origin } });
}
